/*globals window */
define('menuController',['jquery','populateData'], function($,populateData) {
    function setCategoryBarCSS(barElem, menuElem) {
        var elemWidth = menuElem.outerWidth(),
            elemPos = menuElem.position().left;

        barElem.css('width', elemWidth + "px");
        barElem.css({
            '-webkit-transform': 'translateX(' + elemPos + 'px)',
            '-moz-transform': 'translateX(' + elemPos + 'px)',
            '-ms-transform': 'translateX(' + elemPos + 'px)',
            '-o-transform': 'translateX(' + elemPos + 'px)',
            'transform': 'translateX(' + elemPos + 'px)'
        });
    }
    return {
        initMenuBar : function() {

            var $categoryContainer = $('.js-menu-container'),
                $bar = $categoryContainer.find('.bar');

            var $activeElement = $categoryContainer.find('.active>a'),
                $hoverElem;

            //reset the bar back to initial state before we do anything;
            setCategoryBarCSS($bar, $activeElement);

            $(window).off('resize.categoryBar').on('resize.categoryBar', function() {
                setCategoryBarCSS($bar, $activeElement);
            });

            $categoryContainer.on('mouseenter focus', 'li > a', function() {
                $hoverElem = $(this);
                setCategoryBarCSS($bar, $hoverElem);
            });

            $categoryContainer.on('mouseleave blur', 'li > a', function() {
                $activeElement = $categoryContainer.find('.active>a');
                setCategoryBarCSS($bar, $activeElement);
            });

            $categoryContainer.on('click', 'li > a', function() {
                $activeElement = $(this);
                var category = $activeElement.data("category"),
                    categoryText = $activeElement.text();

                $(".js-mobile-menu p").text(categoryText);
                $categoryContainer.find('.active').removeClass("active");
                $activeElement.parent().addClass("active");
                $categoryContainer.removeClass("expanded");
                setCategoryBarCSS($bar, $activeElement);

                populateData.filter(category);
            });

            $(".js-mobile-menu").click(function() {
                $categoryContainer.toggleClass("expanded");
            });

            $("#samsung-promo").on("click", "a", function(ev) {
                if ($(this).attr("href").length > 0 && $(this).attr("href")[0] === "#") {
                    ev.preventDefault();
                    $activeElement = $(".nav-wrapper .nav-section a.nav-option[data-category='*']");
                    if ($(".js-mobile-menu p").text() !== $activeElement.text()) {
                        var category = $activeElement.data("category"),
                            categoryText = $activeElement.text();

                        $(".js-mobile-menu p").text(categoryText);
                        $categoryContainer.find('.active').removeClass("active");
                        $activeElement.parent().addClass("active");
                        $categoryContainer.removeClass("expanded");
                        setCategoryBarCSS($bar, $activeElement);

                        populateData.filter(category);
                        var that = this;
                        window.setTimeout(function() {
                            $('html,body').animate({ scrollTop: $("a[name='" + $(that).attr("href").replace("#", "") + "']").offset().top }, 'slow');
                        }, 400);
                    } else {
                        $('html,body').animate({ scrollTop: $("a[name='" + $(this).attr("href").replace("#", "") + "']").offset().top }, 'slow');
                    }
                }
            });
        }
    };
});

